import React, { useEffect, useState } from 'react';
import './index.css';
import Logo from './Logo';
import axios from 'axios';
import { Config, Connect, ConnectEvents } from '@vkontakte/superappkit';
import { Group, Gallery, Spinner } from '@vkontakte/vkui';
import Lottie from 'react-lottie';
import gmp from './lotties/gmp.json';
import gmpSave from './lotties/save.json';

const tg = window.Telegram.WebApp;
// var MainButton = tg.MainButton;
tg.expand();
// tg.enableClosingConfirmation();
tg.MainButton.hide();
tg.disableVerticalSwipes();
// tg.MainButton.text = tg.initDataUnsafe.user.username
tg.MainButton.color = "#0077ff"

const getUserId = () => tg?.initDataUnsafe?.user?.id || 0;
const tg_id = getUserId();

const urlParams = new URLSearchParams(window.location.search);
const OrderId = urlParams.get('OrderId');

if (OrderId && OrderId.startsWith('GMF')) {
    const keys = [...urlParams.keys()];
    const paymentIdIndex = keys.indexOf('PaymentId');

    if (paymentIdIndex > -1) {
        // Удаляем все параметры после 'PaymentId'
        for (let i = paymentIdIndex + 1; i < keys.length; i++) {
            urlParams.delete(keys[i]);
        }
    }

    // Делаем редирект с "обрезанными" параметрами
    window.location.href = `https://dev.givemefeed.com/?${urlParams.toString()}`;
} else {
    const tg = window.Telegram.WebApp;
}

Config.init({
    appId: 51784114, // Тут нужно подставить ID своего приложения.

    appSettings: {
        agreements: '',
        promo: '',
        vkc_behavior: '',
        vkc_auth_action: '',
        vkc_brand: '',
        vkc_display_mode: '',
    },
});

const sendEventToFlask = (event) => {
    const payload = {
        ...event.payload,
        tg_id: tg.initDataUnsafe.user.id
    };

    axios.post('https://api.gmpapp.ru/gmp_auth', payload)
        .then((response) => {
            window.location.reload();
        })
        .catch((error) => {
            window.location.reload();
        });
};


const oneTapButton = Connect.buttonOneTapAuth({
    callback: (event: VKAuthButtonCallbackResult) => {
        const { type } = event;

        if (!type) {
            return;
        }
        // eslint-disable-next-line
        switch (type) {
            case ConnectEvents.OneTapAuthEventsSDK.LOGIN_SUCCESS: // = 'VKSDKOneTapAuthLoginSuccess'
                sendEventToFlask(event);
                return;
            // Для этих событий нужно открыть полноценный VK ID чтобы
            // пользователь дорегистрировался или подтвердил телефон
            case ConnectEvents.OneTapAuthEventsSDK.FULL_AUTH_NEEDED: //  = 'VKSDKOneTapAuthFullAuthNeeded'
            case ConnectEvents.OneTapAuthEventsSDK.PHONE_VALIDATION_NEEDED: // = 'VKSDKOneTapAuthPhoneValidationNeeded'
            case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN: // = 'VKSDKButtonOneTapAuthShowLogin'
                // url - строка с url, на который будет роизведён редирект после авторизации.
                // state - состояние вашего приложение или любая произвольная строка, которая будет добавлена к url после авторизации.
                return Connect.redirectAuth({ url: 'https://gmpapp.ru/', state: '' })
            // Пользователь перешел по кнопке "Войти другим способом"
            case ConnectEvents.ButtonOneTapAuthEventsSDK.SHOW_LOGIN_OPTIONS: // = 'VKSDKButtonOneTapAuthShowLoginOptions'
            //     // Параметр screen: phone позволяет сразу открыть окно ввода телефона в VK ID
            //     // Параметр url: ссылка для перехода после авторизации. Должен иметь https схему. Обязательный параметр.
            //     return Connect.redirectAuth({ screen: 'phone', url: 'https://gmpapp.ru' });
        }
        return;
    },
    // Не обязательный параметр с настройками отображения OneTap
    options: {
        showAlternativeLogin: false,
        showAgreements: true,
        displayMode: 'default',
        langId: 0,
        buttonSkin: 'primary',
        buttonStyles: {
            borderRadius: 8,
            height: 50,
        },
    },
});


const App = ({ isMobile }) => {
    const totalSlides = 3;  // Общее количество слайдов
    const [slideIndex, setSlideIndex] = useState(0);
    const [buttonName, setButtonName] = useState("Далее");
    const [buttonColor, setButtonColor] = useState("var(--tg-theme-text-color)");
    const [buttonTextColor, setButtonTextColor] = useState("var(--tg-theme-bg-color)");
    const [dragDisabled, setDragDisabled] = useState(false);
    const [loadingScreen, setLoadingScreen] = useState('none');
    const [showArrows, setShowArrows] = useState(true);

    const gmpOpt = {
        loop: true,
        autoplay: true,
        animationData: gmp,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const saveOpt = {
        loop: true,
        autoplay: true,
        animationData: gmpSave,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const slideStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '72px',
    };

    const initialTheme = window.Telegram.WebApp.colorScheme;

    // Инициализируем состояние текущей темы
    const [theme, setTheme] = useState(initialTheme === 'dark' ? 'light' : 'dark');

    useEffect(() => {
        // Задаем таймер, который обновит название кнопки после того как
        // пользователь увидел смену слайда
        const timer = setTimeout(() => {
            if (slideIndex === totalSlides - 1) {
                setButtonName("Войти в сервис");
                setButtonColor("#0965ba");
                setButtonTextColor("#fff")
            } else {
                setButtonName("Далее");
                setButtonColor("var(--tg-theme-text-color)");
                setButtonTextColor("var(--tg-theme-bg-color)")
            }
        }, 200); // 300 мс - предполагаемое время анимации

        // Очищаем таймер при очистке компонента/перерендере
        return () => clearTimeout(timer);
    }, [slideIndex]); // Зависимость только от slideIndex

    useEffect(() => {
        // Функция для обработки события изменения темы
        const handleThemeChange = () => {
            // Получаем текущую тему
            const currentTheme = window.Telegram.WebApp.colorScheme;
            // Меняем местами 'dark' и 'light'
            const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
            setTheme(newTheme); // Обновляем тему в состоянии
        };

        // Подписываемся на событие изменения темы
        window.Telegram.WebApp.onEvent('themeChanged', handleThemeChange);

        // Отписываемся от события при размонтировании компонента
        return () => {
            window.Telegram.WebApp.offEvent('themeChanged', handleThemeChange);
        };
    }, []); // Пустой массив зависимостей, чтобы эффект выполнялся только при монтировании компонента

    const withoutVk = () => {
        const auth_data = {
            "tg_id": tg.initDataUnsafe.user.id,
            "username": tg.initDataUnsafe.user.username
        };

        axios.post('https://api.gmpapp.ru/gmp_auth_without', auth_data)
            .then((response) => {
                window.location.reload();  // Перезагрузить страницу или перенаправить куда-то
            })
            .catch((error) => {
                console.error('Ошибка при отправке события в Flask:', error);
            });
    };

    const nextSlide = () => {
        if (slideIndex < totalSlides - 1) {
            setSlideIndex(slideIndex + 1);
        }
        else {
            setLoadingScreen('flex');  // Показать спиннер сразу
            setTimeout(() => {
                withoutVk();  // Вызов функции отправки данных на последнем слайде
            }, 1000);  // Задержка перед вызовом withoutVk
        }
    };


    const company_auth = () => {
        const auth_data = {
            "tg_id": tg.initDataUnsafe.user.id,
            "username": tg.initDataUnsafe.user.username,
        };

        axios.get('https://api.gmpapp.ru/company_auth', auth_data)
            .then((response) => {
                console.log('Событие успешно отправлено в Flask');
                // window.location.reload();
            })
            .catch((error) => {
                console.error('Ошибка при отправке события в Flask:', error);
            });
    };

    useEffect(() => {
        if (oneTapButton) {
            const loginVK = document.getElementById('loginVK');
            loginVK.appendChild(oneTapButton.getFrame());
        }
    }, []);

    return (
        <div className="welcome">
            <div className="onboarding" style={{ display: "flex" }}>
                <div className="overlaySpinner" style={{ display: loadingScreen }}>
                    <Spinner size="large" />
                </div>
                <Gallery className="onSlider"
                    slideWidth="100%"
                    bullets={theme}
                    align="center"
                    // style={{ height: 460 }}
                    dragDisabled={dragDisabled}
                    slideIndex={slideIndex}
                    onChange={setSlideIndex}
                // showArrows={showArrows}
                >
                    <div className="onSlide">
                        <p style={{ marginTop: 0, fontWeight: 700 }}>ИИ-сммщик, который ведёт соцсети за вас</p>
                        <Logo />
                        <p style={{ paddingBottom: "10px", fontSize: "medium", opacity: ".8" }}>Сделает рерайт нужных источников и сам запостит текст в нужное время</p>
                    </div>
                    <div className="onSlide">
                        <p style={{ marginTop: 0, fontWeight: 700 }}>Публикации будут выходить сами, без участия пользователя.</p>
                        <div className="lottie">
                            <Lottie
                                isClickToPauseDisabled={true}
                                options={gmpOpt}
                                height={200}
                                width={200}
                            />
                        </div>
                        <p style={{ paddingBottom: "10px", fontSize: "medium", opacity: ".8" }}>Один раз настройте сервис и занимайтесь своими делами. Посты будут выходить по расписанию, которое вы установите</p>
                    </div>
                    <div className="onSlide">
                        <p style={{ marginTop: 0, fontWeight: 700 }}>Продвигайте наиболее охватные посты</p>
                        <div className="lottie saveOpt">
                            <Lottie
                                isClickToPauseDisabled={true}
                                options={saveOpt}
                            />
                        </div>
                        <p style={{ paddingBottom: "10px", fontSize: "medium", opacity: ".8" }}>Сервис покажет статистику охватов. Выбирайте наиболее охватные посты для продвижения</p>
                    </div>
                </Gallery>
                <div className="AppBottom">
                    <button onClick={nextSlide} style={{ backgroundColor: buttonColor, color: buttonTextColor }} className="onButton">{buttonName}</button>
                    <div id="loginVK" style={{ display: 'none' }}></div>
                    <div className="terms_body">
                        <Group className="terms_container">
                            <div className="terms"
                                style={{
                                    paddingTop: "10px",
                                    paddingBottom: "2vh",
                                    width: "100%",
                                    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
                                    color: "#99a2ad",
                                    fontSize: "11px",
                                    lineHeight: "14px",
                                    textAlign: "center"
                                }}>
                                <span>Нажимая на кнопку «Войти в сервис», вы принимаете</span>
                                <br />
                                <a style={{ color: "#99a2ad" }}
                                    href="https://docs.google.com/document/d/e/2PACX-1vQQjVQrxiqB-H6D3IfPeUukPceMD4vC9Rpp0csU8xFuGVBhJVbvWhIwrz0kpu7rcv7rHdLVBirDKpXv/pub"
                                    target="_blank"> пользовательское соглашение</a>
                                <a> и</a>
                                <br />
                                <a style={{ color: "#99a2ad" }}
                                    href="https://docs.google.com/document/d/e/2PACX-1vSKQjzra_cK_A8kAlQc0AgB5h5KLqAUPcitYGZkXMH5aUOdJdrqxBBUOuY5X5jyTOr6U8cesX-Y5wlj/pub"
                                    target="_blank">политику в отношении персональных данных</a>
                            </div>
                        </Group>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default App;
export { oneTapButton };